<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="p-1">
                        <form class="" @submit.prevent="submitForm">
                            <div class="row">
                                <div class="form-group col-12 col-md-3">
                                    <label for="phone24">Nombre:</label>
                                    <b-form-input v-model="client_type.type" autocomplete="off"/>
                                    <span v-if="validation_client_type.type" class="text-danger">
                                      {{ validation_client_type.type }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR_CLIENTTYPES_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
    getterType: 'clientType/getField',
    mutationType: 'clientType/updateField',
})

export default {
    name: "FormView",
    components: {
        BCol,
        BRow,
        BCard,
        BFormInput,
        BOverlay,
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('auxiliariesClientTypes', ['validation_client_type']),
        ...mapFields({
            client_type: 'client_type',
        }),
    },
    created() {
        this.$store.commit('auxiliariesClientTypes/RESET_STATE')
        this.$store.commit('auxiliariesClientTypes/CLEAR_VALIDATION')
        if (this.$route.params.id) {
            this.edit = true
            this.getClientTypes()
        } else {
            this.edit = false
        }
        this.$root.$refs.auxiliariesClientTypesForm = this
    },
    methods: {
      getClientTypes() {
            this.showLoading = true

            this.$store.dispatch('clientTypes/findClientTypes', {
                id: this.$route.params.id ?? this.client_type.id
            })
                .then(response => {
                  this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(GEI_AUXILIAR_CLIENTTYPES_LIST)
        },
        createAuxiliar() {
            this.$store.dispatch('clientTypes/createClientTypes', this.client_type)
                .then(response => {
                    helper.showToast('Tipo de cliente creado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_CLIENTTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al crear tipo de cliente', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        updateAuxiliar() {
            this.$store.dispatch('clientTypes/updateClientTypes', this.client_type)
                .then(response => {
                    helper.showToast('Tipo de cliente editado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(GEI_AUXILIAR_CLIENTTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al editar tipo de cliente', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        submitForm() {
            if (this.$route.params.id) {
                this.updateAuxiliar()
            } else {
                this.createAuxiliar()
            }
        },
    },
}
</script>
